function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.5 10a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm-5.477 2a6.472 6.472 0 00-.709 1.5H2.253a.749.749 0 00-.75.75v.577c0 .535.192 1.053.54 1.46 1.253 1.469 3.22 2.214 5.957 2.214.597 0 1.157-.035 1.68-.106.246.495.553.954.912 1.367-.795.16-1.66.24-2.592.24-3.146 0-5.532-.906-7.098-2.74a3.75 3.75 0 01-.898-2.435v-.578A2.249 2.249 0 012.253 12h7.77zm5.477 0l-.09.008a.5.5 0 00-.402.402L15 12.5V15h-2.496l-.09.008a.5.5 0 00-.402.402l-.008.09.008.09a.5.5 0 00.402.402l.09.008H15L15 18.5l.008.09a.5.5 0 00.403.402l.09.008.09-.008a.5.5 0 00.401-.402L16 18.5V16h2.504l.09-.008a.5.5 0 00.402-.402l.008-.09-.008-.09a.5.5 0 00-.402-.402l-.09-.008H16L16 12.5l-.008-.09a.5.5 0 00-.402-.402L15.5 12zM8 .005a5 5 0 110 10 5 5 0 010-10zm0 1.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7z",
  fill: "#8F90A6"
});

function SvgAddUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgAddUser;